import FilterForm from "../../../component/FilterForm/FilterForm";
import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import Select from "react-select";
import {genderList, quantityList} from "./lists";
import SelectInput from "../../../component/SelectInput";
import {ApiUrl} from "../../../auth/authMethods";
import {InputLabelProps} from "../../../utils/InputLabelProps";


export default function FilterAnimal({filter, setFilter, setLoadData, setPage}) {

    const [lgShow, setLgShow] = useState(false);
    const [nomeAnimal, setNomeAnimal] = useState('');
    const [documento, setDocumento] = useState('');
    const [generoAnimal, setGeneroAnimal] = useState('')
    const [quantidade, setQuantidade] = useState('')
    const [eventoId, setEventoId] = useState('');
    const [numeroLote, setNumeroLote] = useState('');

    const [eventoList, setEventoList] = useState([]);

    const handlesSubmit = (e) => {

        e.preventDefault();

        setFilter({
            ...(generoAnimal && {generoAnimal}),
            ...(quantidade && {quantidade}),
            ...(nomeAnimal && {nomeAnimal: nomeAnimal.trim()}),
            ...(documento && {documento: documento.trim()}),
            ...(numeroLote && {numeroLote: numeroLote.trim()}),
            ...(eventoId && {eventoId}),
        });

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setNomeAnimal('')
        setGeneroAnimal('')
        setEventoId('')
        setNumeroLote('')
        setDocumento('')
        setFilter({});

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >

            <SelectInput
                url={ApiUrl + '/evento/list?status=ABERTO&size=20000'}
                list={eventoList}
                set={setEventoList}
                defaultValue={eventoId}
                setObj={setEventoId}
                returnList={() => {
                    let returnList = []
                    eventoList.forEach((item) => {
                        returnList.push({value: item.id, label: `${item.nomeEvento}`})
                    })
                    return returnList
                }}
                placeholder={"Evento"}
                isClearable
                fullWidth
            />
            <TextField
                label="Número do Lote"
                className='mt-2'
                inputProps={{
                    maxLength: 255
                }}
                value={numeroLote}
                onChange={(e) => setNumeroLote(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Nome do Animal"
                className='mt-2'
                inputProps={{
                    maxLength: 255
                }}
                InputLabelProps={InputLabelProps}
                errortext="Campo obrigatório!"
                value={nomeAnimal}
                onChange={(e) => setNomeAnimal(e.target.value)}
                fullWidth
                autoFocus
            />
            <TextField
                label="Documento do Animal"
                className='mt-2'
                inputProps={{
                    maxLength: 255
                }}
                InputLabelProps={InputLabelProps}
                errortext="Campo obrigatório!"
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
                fullWidth
                autoFocus
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={genderList.filter(item => item.value === generoAnimal)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={genderList}
                onChange={(e) => setGeneroAnimal(e?.value)}
                placeholder={'Gênero'}
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={quantityList.filter(item => item.value === quantidade)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={quantityList}
                onChange={(e) => setQuantidade(e?.value)}
                placeholder={'Quantidade'}
            />
        </FilterForm>
    </>
}